import styled from 'styled-components';

export const SoldOutWrapper = styled.div(
  props => `
    flex: 1;
    width: 50%;
    border: 1px solid #E5EDF6;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow:${props.isVideo ? 'hidden' : ''};
  `,
);

export const SoldOutDescWrapper = styled.div(
  props => `
  margin: 12px;
  text-align: right;
  background: ${props.theme.colors.goRed.light};
  padding: 16px;
  border-radius: 8px;
`,
);

export const SoldOutHeaderText = styled.div(
  props => `
  font-weight: 600;
  font-size: 20px;
  color: ${props.theme.colors.goRed.base};
  padding-bottom: 8px;
  padding-top: 12px;
`,
);

export const SoldOutDescText = styled.div(
  props => `
  font-size: 14px;
  color: #141823;
  color: ${props.theme.colors.downriver.base};
`,
);

export const PropertyAvailableText = styled.div(
  props => `
  font-weight: 600;
  font-size: 16px;
  color: ${props.theme.colors.downriver.base};
  text-align:right;
  padding: 4px 12px 12px 0;
`,
);

export const AvailableDateList = styled.ul(
  props => `
  display: flex;
  flex-wrap: no-wrap;
  overflow: auto;
  padding: 0 12px 12px;
  /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
       display: none;
    }

   /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
`,
);

export const AvailableDateListItem = styled.li(
  props => `
  flex-shrink: 0;
  margin-right: 8px;
  border: ${props.isDisabled ? 'none' : `1px solid ${props.theme.colors.goGreen.base}`};
  ${props.isDisabled ? `background-color: ${props.theme.colors.ash.light};` : ''}
  border-radius: 8px;
  text-align:center;
  padding: 8px;
  :last-child {
    margin-right: 0;
  }
  cursor:pointer;
`,
);

export const DateRangeText = styled.p(
  props => `
  color: ${props.isDisabled ? 'rgba(0, 0, 0, 0.5)' : props.theme.colors.downriver.dark};
  font-weight: 600;
  font-size: 14px;
`,
);

export const RoomLeftText = styled.p(
  props => `
  color: ${props.theme.colors.goGreen.base};
  font-weight: 400;
  font-size: 12px;
  padding: 8px 0;
`,
);

export const RoomPriceText = styled.p(
  props => `
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  color: ${props.isDisabled ? 'rgba(0, 0, 0, 0.5)' : props.theme.colors.downriver.dark};
`,
);

export const AltDatesCta = styled.a(
  props => `
  display: inline-block;
  color: #2276E3;
  text-align:right;
  font-weight: 600;
  font-size: 14px;
  padding: 0 12px 12px 0;
`,
);

export const AlternateDateCardLoading = styled.li(
  props => `
    font-size:${props.theme.font.custom(12)};
    padding: 10px;
    flex-shrink: 0;
    border: 1px solid ${props.theme.colors.ash.dark};
    border-radius: 4px;
    margin-right: 6px;
    text-align: center;
    `,
);
